
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/artist/[artistSlug]/featured-in",
      function () {
        return require("private-next-pages/d/artist/[artistSlug]/featured-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/artist/[artistSlug]/featured-in"])
      });
    }
  